import { CalendarDays, List, TrendingUp, X } from "lucide-react";
import { useEffect, useRef } from "react";
import { ChapterNav } from "./ChapterNav";
import type { Heading } from "../types/content";

type MobileReaderControlsProps = {
  headings: Heading[];
  activeHeading: string;
  progress: number;
  tocOpen: boolean;
  onToggleToc: () => void;
};

export function MobileReaderControls({
  headings,
  activeHeading,
  progress,
  tocOpen,
  onToggleToc,
}: MobileReaderControlsProps) {
  const sheetRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (!tocOpen) return;
    const frame = window.requestAnimationFrame(() => {
      sheetRef.current
        ?.querySelector<HTMLAnchorElement>(".chapter-nav a.active")
        ?.scrollIntoView({ block: "center" });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [activeHeading, tocOpen]);

  return (
    <>
      {tocOpen && (
        <div className="mobile-sheet-backdrop" role="presentation" onClick={onToggleToc}>
          <section
            ref={sheetRef}
            className="mobile-toc-sheet"
            role="dialog"
            aria-modal="true"
            aria-label="章节目录"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="sheet-handle" />
            <button type="button" onClick={onToggleToc} aria-label="关闭目录">
              <X aria-hidden="true" />
            </button>
            <ChapterNav
              headings={headings}
              activeHeading={activeHeading}
              onNavigate={onToggleToc}
            />
          </section>
        </div>
      )}
      <nav className="mobile-reader-controls" aria-label="移动端阅读控制">
        <button type="button" onClick={onToggleToc} aria-expanded={tocOpen}>
          <List aria-hidden="true" />
          <span>目录</span>
        </button>
        <a href="#reader">
          <TrendingUp aria-hidden="true" />
          <span>进度 {progress}%</span>
        </a>
        <a href="#weekly-updates">
          <CalendarDays aria-hidden="true" />
          <span>每周更新</span>
        </a>
      </nav>
    </>
  );
}
